import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { vendorService } from '../../services/vendors/vendorService'
import { CreateVendorForm } from '../../types'
import { showSuccessToast, showErrorToast } from '../../utils/errorHandler'

export const useVendors = (params?: { search?: string; active_only?: boolean }) => {
  return useQuery({
    queryKey: ['vendors', params],
    queryFn: () => vendorService.getVendors(params),
  })
}

export const useVendor = (id: string) => {
  return useQuery({
    queryKey: ['vendor', id],
    queryFn: () => vendorService.getVendorById(id),
    enabled: !!id,
  })
}

export const useCreateVendor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateVendorForm) => vendorService.createVendor(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vendors'] })
      showSuccessToast('Vendor created successfully!')
    },
    onError: (error: any) => showErrorToast(error),
  })
}

export const useUpdateVendor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<CreateVendorForm> }) =>
      vendorService.updateVendor(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vendors'] })
      showSuccessToast('Vendor updated successfully!')
    },
    onError: (error: any) => showErrorToast(error),
  })
}

export const useToggleVendorActive = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => vendorService.toggleVendorActive(id),
    onSuccess: (vendor) => {
      queryClient.invalidateQueries({ queryKey: ['vendors'] })
      showSuccessToast(vendor.is_active ? 'Vendor activated.' : 'Vendor deactivated.')
    },
    onError: (error: any) => showErrorToast(error),
  })
}
